// extracted by mini-css-extract-plugin
module.exports = {"error":"Feedback_error__tMblb","formContainer":"Feedback_formContainer__O52U3","label":"Feedback_label__Hai1V"};